import styles from './About.module.css';

export default function About() {
  return (
    <>
      {/* ---- Page header ---- */}
      <section className={styles.header}>
        <div className="container">
          <h1 className={styles.title}>About Us</h1>
          <p className={styles.subtitle}>
            Rooted in culture, driven by innovation.
          </p>
        </div>
      </section>

      {/* ---- Story ---- */}
      <section className="section">
        <div className={`container ${styles.grid}`}>
          <div className={styles.content}>
            <h2>Our Story</h2>
            <p>
              Bohío Kiskeya was founded with a simple mission: to bridge
              tradition and technology. We believe that the most meaningful
              progress honours where we come from while boldly embracing
              where we&rsquo;re going.
            </p>
            <p>
              From our roots in the Dominican Republic, we serve clients
              worldwide — delivering digital experiences, strategic
              consulting, and creative solutions that make a lasting impact.
            </p>
          </div>
          <div className={styles.imagePlaceholder}>
            {/* Replace with actual image from Figma */}
            <span>Image Placeholder</span>
          </div>
        </div>
      </section>

      {/* ---- Values ---- */}
      <section className={`section ${styles.valuesSection}`}>
        <div className="container">
          <h2 className={styles.sectionTitle}>Our Values</h2>
          <div className={styles.values}>
            {VALUES.map(({ title, description }) => (
              <div key={title} className={styles.valueCard}>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

const VALUES = [
  {
    title: 'Heritage',
    description:
      'We honour our cultural roots and infuse authenticity into everything we create.',
  },
  {
    title: 'Excellence',
    description:
      'We hold ourselves to the highest standards of quality and craftsmanship.',
  },
  {
    title: 'Collaboration',
    description:
      'Great work happens when diverse perspectives come together with shared purpose.',
  },
  {
    title: 'Innovation',
    description:
      'We stay curious and embrace new ideas to deliver forward-thinking solutions.',
  },
];
